module.exports = __webpack_public_path__ + "Flag-170.bf3bdd49999efe61abf524d5ed068337.svg";